import type { ReactNode, Ref } from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { LeftNavOpenedIcon } from "@icons";
import { useOptionalSideNavContext } from "./SideNavProvider";
import styles from "./SideNavHeader.module.scss";

/** Hides an open nav; a mini nav hides with `mod+b` only. */
const SideNavHideButton = () => {
    const context = useOptionalSideNavContext();
    if (context === null || context.mode === "mini") {
        return null;
    }

    return (
        <Button
            variant="secondary"
            size="md"
            iconOnly
            aria-label="Hide navigation"
            className={styles.hideButton}
            onClick={() => context.setHidden(true)}
        >
            <LeftNavOpenedIcon />
        </Button>
    );
};

/**
 * The nav's 48px header: a `SideNavPickerTrigger` (inside its `Menu`) on the
 * left, and the hide button on the right while open inside a `SideNavProvider`.
 */
export const SideNavHeader = ({
    picker,
    className,
    ref,
}: {
    picker: ReactNode;
    className?: string;
    ref?: Ref<HTMLDivElement>;
}) => (
    <div ref={ref} className={classNames(styles.header, className)}>
        {picker}
        <SideNavHideButton />
    </div>
);
